import { getLoggedInAsUser } from './helper'

const loggedInAsUser = getLoggedInAsUser()

export default {
  isLogInAs: !!loggedInAsUser,
  impersonatedUser: loggedInAsUser || {},
  impersonatedUserPermissions: []
}
